import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";

const TextEditor = ({
  defaultValue = "",
  value,
  onChange,
  editable = true,
  maxWords,
}) => {
  const [internalValue, setInternalValue] = useState(
    value
      ? value?.replaceAll("\\n", "<br>")
      : defaultValue?.replaceAll("\\n", "<br>")
  );
  const [quillState, setQuillState] = useState(null);
  const [prevContent, setPrevContent] = useState("");
  const [shownError, setShownError] = useState(false);
  // const [wordLimitExceeded, setWordLimitExceeded] = useState(false);

  // useEffect(() => {

  // }, [value]);
  const getStrippedContent = (content) => {
    content?.replaceAll("<p>", "\n"); // Escape the newline character
    return content?.replaceAll(/<[^>]*>/g, " "); // Remove HTML tags
  };

  const totalWords =
    getStrippedContent(internalValue) &&
    getStrippedContent(internalValue)
      .trim()
      .split(" ")
      .filter((word) => word.length > 0).length;
  useEffect(() => {
    if (value !== undefined) {
      setInternalValue(value);
    } else {
      setInternalValue(defaultValue);
    }
  }, [defaultValue, value]);

  const handleChange = (content) => {
    if (onChange) {
      const wordCount = getStrippedContent(content)
        .trim()
        .split(" ")
        .filter((word) => word.length > 0).length;

      if (maxWords && wordCount <= maxWords) {
        onChange(content); // Call onChange if provided
        setPrevContent(content);
      } else if (maxWords && wordCount > maxWords) {
        setShownError(true);
        {
          !shownError &&
            toast.error(
              `Word limit of ${maxWords} exceeded! Excess words will be removed.`
            );
        } // Notify user
      } else if (!maxWords) {
        onChange(content);
      }
      setInternalValue(content);
    }
  };

  return (
    <div>
      <div className="text-editor h-fit w-full overflow-hidden overflow-y-auto">
        <ReactQuill
          value={internalValue}
          onChange={handleChange}
          modules={TextEditor.modules}
          formats={TextEditor.formats}
          readOnly={!editable}
          className="font-poppins text-xs md:text-xl p-0 w-full h-auto"
          ref={(el) => {
            setQuillState(el);
          }}
        />
        {/* Display word count if maxWords is defined */}
      </div>
      {maxWords && (
        <div className={`text-right text-sm text-gray-500 mt-0 pt-2`}>
          <span
            className={
              maxWords && totalWords > maxWords && "text-red-500 font-bold mr-1"
            }
          >
            {totalWords}
          </span>
          /{maxWords} words
        </div>
      )}
    </div>
  );
};

TextEditor.modules = {
  toolbar: [
    [
      // { 'header': '1' }, { 'header': '2' }, { 'header': '3' }, { 'header': '4' },
      { font: [] },
    ],

    // ['bold', 'italic', 'underline'],
    [
      // { 'list': 'ordered' },
      { list: "bullet" },
    ],
  ],
};

TextEditor.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];

export default TextEditor;
